module.exports = __webpack_public_path__ + "img/inteligenio.054357aa.png";